import React from 'react'

const FeatureCard = ({ icon, title, desc }) => (
  <div style={styles.featureCard}>
    <div style={styles.featureIcon}>{icon}</div>
    <div style={styles.featureTitle}>{title}</div>
    <div style={styles.featureDesc}>{desc}</div>
  </div>
)

const Index = () => {
  return (
    <div style={styles.page}>
      {/* Decorative blobs */}
      <div style={styles.blobTop} />
      <div style={styles.blobBottom} />

      {/* Navbar */}
      <nav style={styles.nav}>
        <div style={styles.navBrand}>
          <img src={require('./images/30516.jpg')} alt="Swan Industry Thailand" style={styles.navLogo} />
        </div>
      </nav>

      {/* Hero */}
      <div style={styles.hero}>
        <div style={styles.heroBadge}>Electronic Tax Document System</div>

        <div style={styles.logoWrap}>
          <img src={require('./images/30516.jpg')} alt="Swan Industry Thailand" style={styles.logoImg} />
        </div>

        <h1 style={styles.heroTitle}>
          Swan <span style={styles.heroTitleAccent}>E-TDS</span>
        </h1>
        <p style={styles.heroSub}>
          ระบบเอกสารภาษีอิเล็กทรอนิกส์<br />
          <span style={styles.heroSubLight}>Swan Industries Thailand</span>
        </p>

        <div style={styles.heroCtas}>
          <a href="/login" style={styles.btnPrimary}>เริ่มต้นใช้งาน</a>
          <a href="/login" style={styles.btnSecondary}>เข้าสู่ระบบ</a>
        </div>

        <div style={styles.version}>Version 1.0</div>
      </div>

      {/* Features */}
      <div style={styles.features}>
        <FeatureCard
          icon={<span style={styles.featureEmoji}>📄</span>}
          title="จัดการเอกสาร"
          desc="สร้างและติดตามเอกสาร TDS ได้ในที่เดียว"
        />
        <FeatureCard
          icon={<span style={styles.featureEmoji}>✅</span>}
          title="ระบบอนุมัติ"
          desc="เวิร์กโฟลว์อนุมัติหลายระดับ รวดเร็วและแม่นยำ"
        />
        <FeatureCard
          icon={<span style={styles.featureEmoji}>📊</span>}
          title="รายงานสรุป"
          desc="ดูสถานะและรายงานแบบ Real-time"
        />
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        © 2024 Swan Industries Thailand · E-TDS System · All rights reserved.
      </div>
    </div>
  )
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(160deg, #e8f5e9 0%, #c8e6c9 40%, #a5d6a7 100%)',
    fontFamily: "'Segoe UI', 'Tahoma', sans-serif",
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  blobTop: {
    position: 'absolute',
    top: -120,
    right: -100,
    width: 420,
    height: 420,
    borderRadius: '50%',
    background: 'rgba(129,199,132,0.35)',
    filter: 'blur(60px)',
    pointerEvents: 'none',
  },
  blobBottom: {
    position: 'absolute',
    bottom: -140,
    left: -100,
    width: 460,
    height: 460,
    borderRadius: '50%',
    background: 'rgba(165,214,167,0.4)',
    filter: 'blur(80px)',
    pointerEvents: 'none',
  },

  /* Navbar */
  nav: {
    width: '100%',
    maxWidth: 900,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 32px',
    boxSizing: 'border-box',
    zIndex: 10,
  },
  navBrand: {
    display: 'flex',
    alignItems: 'center',
  },
  navLogo: {
    height: 40,
    borderRadius: 6,
    objectFit: 'contain',
    boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
  },

  /* Hero */
  hero: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 40,
    paddingBottom: 20,
    zIndex: 10,
    textAlign: 'center',
    padding: '40px 24px 20px',
  },
  heroBadge: {
    backgroundColor: 'rgba(67,160,71,0.15)',
    color: '#2e7d32',
    border: '1px solid rgba(67,160,71,0.3)',
    borderRadius: 30,
    padding: '5px 18px',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 1,
    marginBottom: 28,
    textTransform: 'uppercase',
  },
  logoWrap: {
    borderRadius: 16,
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 16px 48px rgba(67,160,71,0.3)',
    marginBottom: 28,
    padding: '10px 18px',
  },
  logoImg: {
    height: 70,
    objectFit: 'contain',
  },
  heroTitle: {
    fontSize: 52,
    fontWeight: 800,
    color: '#1b5e20',
    margin: 0,
    letterSpacing: -1,
    lineHeight: 1.1,
  },
  heroTitleAccent: {
    color: '#43a047',
  },
  heroSub: {
    fontSize: 18,
    color: '#388e3c',
    marginTop: 14,
    marginBottom: 36,
    lineHeight: 1.7,
  },
  heroSubLight: {
    fontSize: 14,
    color: '#66bb6a',
    fontWeight: 400,
  },
  heroCtas: {
    display: 'flex',
    gap: 16,
    marginBottom: 20,
  },
  btnPrimary: {
    padding: '13px 36px',
    background: 'linear-gradient(135deg, #43a047, #2e7d32)',
    color: '#fff',
    borderRadius: 50,
    textDecoration: 'none',
    fontSize: 15,
    fontWeight: 700,
    boxShadow: '0 8px 24px rgba(67,160,71,0.4)',
    letterSpacing: 0.3,
  },
  btnSecondary: {
    padding: '13px 36px',
    background: 'rgba(255,255,255,0.7)',
    color: '#2e7d32',
    borderRadius: 50,
    textDecoration: 'none',
    fontSize: 15,
    fontWeight: 600,
    border: '1.5px solid rgba(67,160,71,0.35)',
    backdropFilter: 'blur(8px)',
  },
  version: {
    fontSize: 11,
    color: '#81c784',
    marginTop: 8,
    letterSpacing: 1,
  },

  /* Features */
  features: {
    display: 'flex',
    gap: 20,
    padding: '20px 24px 0',
    zIndex: 10,
    flexWrap: 'wrap',
    justifyContent: 'center',
    maxWidth: 860,
  },
  featureCard: {
    background: 'rgba(255,255,255,0.65)',
    backdropFilter: 'blur(12px)',
    borderRadius: 18,
    padding: '24px 28px',
    flex: '1 1 220px',
    maxWidth: 250,
    border: '1px solid rgba(255,255,255,0.8)',
    boxShadow: '0 8px 32px rgba(67,160,71,0.1)',
    textAlign: 'center',
  },
  featureEmoji: {
    fontSize: 32,
  },
  featureIcon: {
    marginBottom: 12,
  },
  featureTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: '#2e7d32',
    marginBottom: 6,
  },
  featureDesc: {
    fontSize: 13,
    color: '#558b2f',
    lineHeight: 1.6,
  },

  /* Footer */
  footer: {
    marginTop: 'auto',
    padding: '28px 24px 24px',
    fontSize: 11,
    color: '#81c784',
    textAlign: 'center',
    zIndex: 10,
  },
}

export default Index
